let cvs = null;

const createCanvas = () => {
    if (!cvs) {
        cvs = document.createElement('canvas');
    }

    return cvs;
};

export default createCanvas;
